module.exports = __webpack_public_path__ + "img/news3-1.7d12c187.png";